import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogueHandler, ChangePasswordDialogueHandler } from '../types';
import ChangeUserPasswordContext from './ChangeUserPasswordContext';

const { ConfirmationDialogue } = vp;

type ChangePasswordDialogueProps = {
  handleDialogue: DialogueHandler<ChangePasswordDialogueHandler>;
};

type FC = FunctionComponent<ChangePasswordDialogueProps>;

const ChangePasswordDialogue: FC = ({ handleDialogue }: ChangePasswordDialogueProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'Users.ChangeUserPassword.ChangeUserPasswordDialogue' });
  const { showChangeUserPasswordSuccessAlert, showChangeUserPasswordErrorAlert, ChangeUserPasswordError } =
    useContext(ChangeUserPasswordContext);
  return useMemo(
    () => (
      <div>
        {/* Change Password Error */}
        <ConfirmationDialogue
          isVisible={showChangeUserPasswordErrorAlert}
          title={t('errorTitle')}
          status="error"
          subTitle={t('errorSubTitle', { ChangeUserPasswordError })}
          confirm={{
            label: t('backButton'),
            action: () => handleDialogue({ type: 'change', state: 'fail' }),
          }}
        />
        {/* Change Password Success */}
        <ConfirmationDialogue
          isVisible={showChangeUserPasswordSuccessAlert}
          title={t('successTitle')}
          status="success"
          subTitle={t('successSubTitle')}
          confirm={{
            label: t('backToUsersButton'),
            action: () => handleDialogue({ type: 'change', state: 'success' }),
          }}
        />
      </div>
    ),
    [showChangeUserPasswordSuccessAlert, showChangeUserPasswordErrorAlert],
  );
};

export default ChangePasswordDialogue;
